export const MB_TO_BYTES = 1024 * 1024
export const MB_5_LIMIT = 5
export const MB_10_LIMIT = 10
export const MB_15_LIMIT = 15

export const getLimitInBytes = (limit: number = MB_10_LIMIT) => {
  return limit * MB_TO_BYTES
}
